var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllAboutMeAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1475,
    height: 2316,
    viewBox: "0 0 1475 2316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1223.9 1828.34V2437.12H617.836L307.474 2123.3L2 1828.34V1219.56H612.948L1223.9 1828.34ZM1223.9 1828.34L1529.37 2123.3L1839.73 2437.12H2445.79V1828.34L1834.84 1219.56H1223.9M1223.9 1828.34V1219.56M1223.9 1219.56V610.781M1223.9 1219.56H617.836L307.474 905.736L2 610.781V2H612.948L1223.9 610.781M1223.9 610.781L1529.37 905.736L1839.73 1219.56H2445.79V610.781L1834.84 2H1223.9V610.781Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAboutMeAttract);
export default __webpack_public_path__ + "static/media/all-about-me-attract.f507e7cb374d7c5896471cb243616072.svg";
export { ForwardRef as ReactComponent };